import React from "react";

import { useCartController } from "@/contexts/CartControllerContext";
import { useViewport } from "@/contexts/ViewportContext";
import { OrderItem } from "@/interfaces/domain/Order";

import ProductListMobile from "./ProductList.mobile";
import ProductListWeb from "./ProductList.web";
import { ProductListProps } from "./types";

type ComponentProps = Omit<ProductListProps, "onPressDecrease" | "onPressIncrease">;

const ProductList = ({ data, isLoading, isLoadingMore, onLoadMore, onSelect }: ComponentProps) => {
  const { isWebMode } = useViewport();

  const { decreaseItem, increaseItem } = useCartController();

  const items = isLoading ? Array<OrderItem>(isWebMode ? 20 : 10).fill(null) : data;

  const Component = isWebMode ? ProductListWeb : ProductListMobile;

  return (
    <Component
      data={items}
      isLoading={isLoading}
      isLoadingMore={isLoadingMore}
      onSelect={onSelect}
      onLoadMore={onLoadMore}
      onPressDecrease={decreaseItem}
      onPressIncrease={increaseItem}
    />
  );
};

export default ProductList;
